import { render, staticRenderFns } from "./productAdmin.vue?vue&type=template&id=1110b694"
import script from "./productAdmin.vue?vue&type=script&lang=js"
export * from "./productAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports